import _ from 'lodash';
import store from '../store/index';
import * as fb from '../firebase';
import userService from './user.service';

export default {
  getRef(workspaceId) {
    return fb.workspacesCollection.doc(workspaceId);
  },

  getWorkspace(workspaceId) {
    return this.getRef(workspaceId)
      .get()
      .then((workspace) => workspace.data());
  },

  deleteWorkspace(workspaceId, userId) {
    return this.getRef(workspaceId)
      .delete()
      .then(() => {
        // delete from user
        userService.removeWorkspace(userId, workspaceId);
      });
  },

  async quitWorkspace(workspaceId, userRef) {
    const user = await userRef.get();
    const userData = user.data();
    if (userData) {
      const { workspaces } = userData;
      const newWorkspaces = [];
      // On reprend tous les workspaces SAUF celui qu'on doit enlever
      workspaces.forEach((workspace) => {
        if (workspace.id !== workspaceId) {
          // Si c'est un autre, on le garde
          newWorkspaces.push(workspace);
        }
      });
      return userRef.update({ workspaces: newWorkspaces });
    }
    throw new Error(`[quitWorkspace] no user ${userRef.id}`);
  },

  /**
   * Récupération des refs des workspaces
   */
  getWorkspacesRef(checkInLimit = false) {
    // Récupération des workspaces de l'user
    const allWorkspacesRef = _.get(
      store.state.userProfile,
      'workspaces',
      []
    ).map((ws) => fb.workspacesCollection.doc(ws.id));
    // La fonction "in" de firestore pour 10 champs max
    if (checkInLimit && allWorkspacesRef.length > 10) {
      throw new Error('[MyMeals] - Max 10 workspaces');
    }
    return allWorkspacesRef;
  },
};
